import { render, staticRenderFns } from "./PostElement.vue?vue&type=template&id=b6aae626&"
import script from "./PostElement.vue?vue&type=script&lang=js&"
export * from "./PostElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports